<!-- 粉丝消息 -->
<template>
<div class="fans-meesage-box">
	<img src="../../assets/fans_message_img.jpeg" style="width: 100%;height: 100%;filter: blur(50px);pointer-events: none;" alt="">
	<div class="content-father-box">
		<div class="content-big-box">
			
			<!-- 渠道-公众号选择列 -->
			<div @click="hidenEmoji" class="big-left-box">
				<div style="margin-bottom: 10px;">
					<a-select
						show-search
						style="width: 200px"
						placeholder="请选择渠道"
						@change="handleChangeB"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						:value="r_channel_id"
					  >
						<a-select-option v-for="(item,index) in bookList" :key="index" :value="item.channel_id">
							<div style="display: flex;justify-content: space-between;width: 100%;align-items: center;">
								<div>{{item.channel_name}}</div>
								<div v-if="(item.channel_id != r_channel_id) && item.no_read_message > 0" style="width: 5px;height: 5px;background-color: red;border-radius: 20px;"></div>
							</div>
						</a-select-option>
					</a-select>
				</div>
				
				<div class="left-menu-box" style="height: calc(100% - 30px);overflow-y: overlay;">
					<div v-for="(item,index) in gzhSelect"
					:class="[ item.click_status? 'left-children-cell-true':'', ]"
					@click="menuSecond(item,index)" class="left-children-cell" >
						{{item.value}}
						<div v-if="item.msg_prompt_read > 0" class="center-header-hint" style="height: 19.5px;margin-right: 10px;">{{item.msg_prompt_read>999?'999+':item.msg_prompt_read}}</div>
					</div>
				</div>
			</div>
			
			<!-- 消息列 -->
			<div @click="hidenEmoji" class="big-center-box" >
				<div style="padding: 10px 12px;background-color: #fafafa;height: 52px;display: flex;align-items: center;">
					<!-- <a-input-search placeholder="搜索粉丝名" @search="onSearchChal" /> -->
					<!-- <div style="font-size: 16px;">粉丝消息</div> -->
				</div>
				<div class="center-all-cell" @scroll="fansMsgScroll">
					<!-- <div v-if="fansMsgData.length > 0" style="width: 100%;height: 10px;"></div> -->
					<template v-if="fansMsgData.length > 0">
						<div class="center-cell-box" v-for="(item,index) in fansMsgData" @click="clickFansMsg(item,index)" :class="[ item.fans_select_status? 'center-cell-box-true':'', ]">
							<img class="center-header-img" :src="item.headimgurl || 'https://oss.ledu6.cn/gzh/headimg/otRVlwXvoFh2tvSZhh5gVnA2VDjA.png.png'" alt="">
							<div class="center-text-box">
								<div style="display: flex;justify-content: space-between;">
									<h2 v-if="item.nickname" class="center-header-name" >{{item.nickname}}</h2>
									<h2 v-else class="center-header-name" style="font-size: 12px;">用户({{item.openid}})</h2>
									<!-- <span style="color: gray;font-size: 10px;">14:42</span> -->
									<span v-if="item.new_messages_count != 0" class="center-header-hint">{{item.new_messages_count>999?'999+':item.new_messages_count}}</span>
								</div>
								<div class="center-text-msg" >
									{{item.last_message.msg_content || ""}}
								</div>
							</div>
						</div>
					</template>
					<template v-else>
						<a-empty :image="simpleImage" />
					</template>
				</div>
			</div>
			
			<!-- 聊天窗口 -->
			<div class="big-right-box" style="">
				<div @click="hidenEmoji" style="height: 52px;border-bottom: 1px solid #e6e6e6;display: flex;align-items: center;background-color: #f5f5f5;flex-shrink：0">
					<h1 style="font-size: 16px;margin-bottom: 0;padding-left:20px;">{{messages_name}}</h1>
				</div>
				
				<div @click="hidenEmoji" class="message-scrol-box">
					<div class="big-right-message" ref="chatBox" @scroll="fansChatScroll">
						<div v-for="(item,index) in chatData" :key="item.msg_id">
							<!-- 日期时间 -->
							<p v-if="item.created_at" style="align-self: center;margin-bottom: 0;color: #b4b4b4;height: 20px;font-size: 10px;text-align: center;">
							{{item.created_at | dateFilters}}
							</p>
							<!-- 左边 -->
							<div v-if="item.sender == 0" style="padding: 10px 0;display: flex;">
								<img v-if="messages_img" style="width: 40px;height: 40px;user-select: none;" :src="messages_img" alt="">
								<img v-else style="width: 40px;height: 40px;user-select: none;" src="../../assets/customer-icon2.png" alt="">
								<div v-if="item.msg_type == 1" class="text-message-container">
									<div class="arrow-box-left" style=""></div>
								   <p class="text" v-html="`${item.msg_content}`" ></p>
								</div>
								<div v-else>
									<img style="max-width: 300px;max-height: 370px;margin-left: 10px;" :src="item.msg_content" alt="">
								</div>
							</div>
							<!-- 右边 -->
							<template v-else>
								<div style="padding: 10px 0;display: flex;justify-content: flex-end;">
									<div v-if="item.msg_type == 1" class="text-message-container">
										<div class="arrow-box-right" style=""></div>
										<p class="text" v-html="`${item.msg_content}`" ></p>
									</div>
									<div v-else>
										<img style="max-width: 300px;max-height: 370px;margin-right: 10px;" :src="item.msg_content" alt="">
									</div>
									<img style="width: 40px;height: 40px;user-select: none;" src="../../assets/customer-icon.png" alt="">
								</div>
								
							</template>
						</div>
					</div>
				</div>
				
				<div style="border-top: 1px solid #e2e2e2;height: 245px;flex-shrink：0">
					<div style="padding: 7px 15px;">
						<div style="display: inline-block;position:relative;margin-right: 20px;">
							<a-icon @click="showEmoji" type="smile" style="font-size: 20px;cursor: pointer;color: #555;" />
							<div v-show="emoji_box_control" style="background-color: #fff;width: 610px;min-height:246px;position: absolute;bottom: 35px;transform: translateX(-50%);box-shadow: 0 0 10px 3px #ccc;border-radius: 6px;padding: 10px 5px 5px 10px;">
								<template v-for="(value,key) in emojiList">
									<img @click="clickEmoji(value,key)" class="emoji-img" style="" :src="value" alt="">
								</template>
							</div>
						</div>
						<a-icon @click="showImgModal" type="picture" style="font-size: 20px;cursor: pointer;color: #555;" />
					</div>
					
					<div>
						<template v-if="chat_window_type == 1">
							<Editor
							    style="height: 160px;overflow-y: hidden;background-color: transparent;"
							    v-model="html_"
							    :defaultConfig="editorConfig"
							    :mode="mode"
							    @onCreated="onCreated"
								@customPaste="customPaste"
							/>
						</template>
						
						<template v-else>
							<div class="msg-img-box">
								<img style="max-width: 260px;max-height: 135px;" 
								:src="r_img_url" alt="">
								<img @click="delChatImg" class="msg-img-del-icon" src="../../assets/delete-icon.png" alt="">
							</div>
						</template>
						
					</div>
					
					<div class="send-box">
						<h2 @click="sendButton" class="send-button">发 送</h2>
					</div>
				</div>
			</div>
			
		</div>
	</div>
	
	<a-modal
	      title="图库"
	      :visible="img_visible"
	      :confirm-loading="img_confirmLoading"
	      @ok="imgHandleOk"
	      @cancel="imgHandleCancel"
		  width="1170px"
	    >
		<div style="margin: -10px 0;position: relative;">
			<div style="margin-bottom: 15px;display: flex;align-items: center;justify-content: space-between;padding-right:10px;">
				<div style="display: flex;align-items: center;">
					<a-upload
						accept="image/*"
						name="image"
						class="avatar-uploader"
						:show-upload-list="false"
						:action="`${$http.excel_url}api/platform/gzh/upload-material`"
						:data="{
							'name': upload_gzh_name || 'Image.png',
							'id': upload_gzh_id,
						}"
						:headers="{
							'Authorization': headers_token
						}"
						:withCredentials="true"
						method="post" 
						:before-upload="beforeUpload"
						@change="uploadChange"
					  >
						<a-button type="primary" style="">
							<a-icon type="upload" />本地上传
						</a-button>
					</a-upload>
					<div style="margin-left: 30px;color:#999999;">
						请确保您选择的图片不会有版权纠纷，建议尺寸200px*200px以上
					</div>
				</div>
				<a-button @click="syncImg" :loading="img_sync_loading" type="primary" style="">
					同步素材
				</a-button>
			</div>
			<div>
				<!-- 选择封面 -->
				<img v-for="(item,index) in imgShowData" @click='clickShowImg(index)'   
				 :class="[item.select_img?'select_img-border':'']" 
				style="width: 150px;height: 130px;margin: 0 10px 10px 0;cursor: pointer;object-fit: contain;border: 1px solid #eee;" 
				:src="item.url" alt="">
				<!-- 内容为空提示 -->
				<div class="img-content-null" v-show="imgShowData.length == 0">
					<a-icon style="font-size: 70px;color: #999;" type="file-search" />
					<div class="img-content-null-text">内容为空</div>
				</div>
			</div>
			<a-pagination v-model="img_page" :pageSize="img_limit" :total="img_total" @change="imgPagingChange"
			style="text-align: center;margin-top: 15px;" />
			
			<div class="img_loading" v-show="img_search_loading">
				<a-spin size="large" />
			</div>
		</div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { Editor } from '@wangeditor/editor-for-vue'
import { Empty } from 'ant-design-vue';
import { opeGzhSelect, wxMaterialSelect, gzhFansMsgList, gzhFansChannelList, gzhFansMsgRead, gzhFansChat, gzhFansSendMsg, gzhFansGetImg, gzhFansSyncImg } from '@/request/api'
var timer = null
export default {
	name: 'fansMessage_',
	components: { Editor },
	data() {
		return {
			searchSelect: {
				user: {},
				channel:{}
			}, // 渠道，公众号 下拉框数据
			
			bookList: [], // 渠道下拉
			gzhSelect: [], // 公众号下拉
			
			r_channel_id: undefined,
			r_gzh_id: undefined,
			
			search_button_loading: false,
			
			editor: null,
			html_: "",
			editorConfig: {
				placeholder: '',
				MENU_CONF : {
				    fontSize: {
						fontSizeList: [
							'12px',
							'13px',
							'14px',
							'15px',
							'16px',
							'17px',
							'18px',
							'19px',
							'20px',
							'21px',
							'22px',
							'23px',
							'24px',
							'25px',
							'26px',
							'27px',
							'28px',
							'29px',
							'30px',
							'31px',
							'32px',
							'33px',
							'34px',
							'35px',
							'36px',
							'37px',
							'38px',
							'39px',
							'40px',
							'41px',
							'42px',
							'43px',
							'44px',
							'45px',
							'46px',
							'47px',
							'48px',
							'49px',
							'50px',
						]
					},
					lineHeight: {
						lineHeightList: ['1', '1.5','1.6','1.7','1.8','1.9','2','2.1','2.2','2.3','2.4','2.5','2.6','2.7','2.8','2.9','3']
					},
					// uploadImage: {
					// 	// 自定义上传
					// 	// async customUpload(file: File, insertFn: InsertFnType) {  // TS 语法
					// 	async customUpload(files, insertFn) {  // JS 语法
					// 		console.log("customUpload",files);
							
					// 		var params = new FormData()
					// 		params.append('file', files)
					// 		params.append('type', 5)
							
					// 		// file 即选中的文件
					// 		// 自己实现上传，并得到图片 url alt href
					// 		landAddUploadImage(params).then(res=>{
					// 			console.log("微信图文消息",res);
								
					// 			// 最后插入图片。这是wangEditor富文本自己的方法
					// 			insertFn(res.data.data.url, '', '')
					// 		})
							
					// 	}
					// }
				},
				readOnly: false,
			},
			mode: 'simple', // or 'simple'
			upload_gzh_name: '',
			fansMsgData: [],
			fans_page: 1,
			fans_scroll_control: true,
			gzh_msg_interval: null, // 计时器
			timer: null,
			
			simpleImage: "",
			
			messages_name: "",
			messages_img: "",
			send_openid: null, // 当前聊天框的用户的openid
			
			chatData: [], // 获取聊天信息
			chat_msg_num: 0, // 表示未读/新增消息数量
			
			img_visible: false, // 图片弹窗
			img_confirmLoading: false,
			imgShowData: [], // 图片数据
			img_page: 1,
			img_limit: 20,
			img_total: 0,
			headers_token: "", // 图片上传用的token
			img_sync_loading: false,
			r_img_media_id: null,
			r_img_url: null,
			chat_window_type: 1, // 1文本编辑器，2图片
			img_search_loading: false,
			
			select_fans_index: null, // 当前选中的粉丝索引
			chat_scrollTop_control: false,
			chat_page: 1,
			chat_total: 0,
			chat_user_id: null,
			
			emojiList: {
				"/::)": "//oss.ledu6.cn/emoji/001.png",
				"/::~": "//oss.ledu6.cn/emoji/002.png",
				"/::B": "//oss.ledu6.cn/emoji/003.png",
				"/::|": "//oss.ledu6.cn/emoji/004.png",
				"/:8-)": "//oss.ledu6.cn/emoji/005.png",
				"/::<": "//oss.ledu6.cn/emoji/006.png",
				"/::$": "//oss.ledu6.cn/emoji/007.png",
				"/::X": "//oss.ledu6.cn/emoji/008.png",
				"/::Z": "//oss.ledu6.cn/emoji/009.png",
				"/::'(": "//oss.ledu6.cn/emoji/010.png",
				"/::-|": "//oss.ledu6.cn/emoji/011.png",
				"/::@": "//oss.ledu6.cn/emoji/012.png",
				"/::P": "//oss.ledu6.cn/emoji/013.png",
				"/::D": "//oss.ledu6.cn/emoji/014.png",
				"/::O": "//oss.ledu6.cn/emoji/015.png",
				"/::(": "//oss.ledu6.cn/emoji/016.png",
				"[酷]": "//oss.ledu6.cn/emoji/017.png",
				"/:--b": "//oss.ledu6.cn/emoji/018.png",
				"/::Q": "//oss.ledu6.cn/emoji/019.png",
				"/::T": "//oss.ledu6.cn/emoji/020.png",
				"/:,@P": "//oss.ledu6.cn/emoji/021.png",
				"/:,@-D": "//oss.ledu6.cn/emoji/022.png",
				"/::d": "//oss.ledu6.cn/emoji/023.png",
				"/:,@o": "//oss.ledu6.cn/emoji/024.png",
				"[饥饿]": "//oss.ledu6.cn/emoji/025.png",
				"/:|-)": "//oss.ledu6.cn/emoji/026.png",
				"/::!": "//oss.ledu6.cn/emoji/027.png",
				"/::L": "//oss.ledu6.cn/emoji/028.png",
				"[憨笑]": "//oss.ledu6.cn/emoji/029.png",
				"/::,@": "//oss.ledu6.cn/emoji/030.png",
				"/:,@f": "//oss.ledu6.cn/emoji/031.png",
				"/::-S": "//oss.ledu6.cn/emoji/032.png",
				"/:?": "//oss.ledu6.cn/emoji/033.png",
				"/:,@x": "//oss.ledu6.cn/emoji/034.png",
				"/:,@@": "//oss.ledu6.cn/emoji/035.png",
				"[疯了]": "//oss.ledu6.cn/emoji/036.png",
				"/:,@!": "//oss.ledu6.cn/emoji/037.png",
				"/:!!!": "//oss.ledu6.cn/emoji/038.png",
				"/:xx": "//oss.ledu6.cn/emoji/039.png",
				"/:bye": "//oss.ledu6.cn/emoji/040.png",
				"/:wipe": "//oss.ledu6.cn/emoji/041.png",
				"/:dig": "//oss.ledu6.cn/emoji/042.png",
				"/:handclap": "//oss.ledu6.cn/emoji/043.png",
				"[糗大了]": "//oss.ledu6.cn/emoji/044.png",
				"/:B-)": "//oss.ledu6.cn/emoji/045.png",
				"/:<@": "//oss.ledu6.cn/emoji/046.png",
				"[右哼哼]": "//oss.ledu6.cn/emoji/047.png",
				"/::-O": "//oss.ledu6.cn/emoji/048.png",
				"[鄙视]": "//oss.ledu6.cn/emoji/049.png",
				"/:P-(": "//oss.ledu6.cn/emoji/050.png",
				"/::'|": "//oss.ledu6.cn/emoji/051.png",
				"/:X-)": "//oss.ledu6.cn/emoji/052.png",
				"/::*": "//oss.ledu6.cn/emoji/053.png",
				"[吓]": "//oss.ledu6.cn/emoji/054.png",
				"/:8*": "//oss.ledu6.cn/emoji/055.png",
				"/:pd": "//oss.ledu6.cn/emoji/056.png",
				"[西瓜]": "//oss.ledu6.cn/emoji/057.png",
				"/:beer": "//oss.ledu6.cn/emoji/058.png",
				"[篮球]": "//oss.ledu6.cn/emoji/059.png",
				"[乒乓]": "//oss.ledu6.cn/emoji/060.png",
				"/:coffee": "//oss.ledu6.cn/emoji/061.png",
				"[饭]": "//oss.ledu6.cn/emoji/062.png",
				"/:pig": "//oss.ledu6.cn/emoji/063.png",
				"/:rose": "//oss.ledu6.cn/emoji/064.png",
				"/:fade": "//oss.ledu6.cn/emoji/065.png",
				"/:showlove": "//oss.ledu6.cn/emoji/066.png",
				"/:heart": "//oss.ledu6.cn/emoji/067.png",
				"/:break": "//oss.ledu6.cn/emoji/068.png",
				"/:cake": "//oss.ledu6.cn/emoji/069.png",
				"[闪电]": "//oss.ledu6.cn/emoji/070.png",
				"/:bome": "//oss.ledu6.cn/emoji/071.png",
				"[刀]": "//oss.ledu6.cn/emoji/072.png",
				"[足球]": "//oss.ledu6.cn/emoji/073.png",
				"[瓢虫]": "//oss.ledu6.cn/emoji/074.png",
				"/:shit": "//oss.ledu6.cn/emoji/075.png",
				"/:moon": "//oss.ledu6.cn/emoji/076.png",
				"/:sun": "//oss.ledu6.cn/emoji/077.png",
				"[礼物]": "//oss.ledu6.cn/emoji/078.png",
				"/:hug": "//oss.ledu6.cn/emoji/079.png",
				"/:strong": "//oss.ledu6.cn/emoji/080.png",
				"/:weak": "//oss.ledu6.cn/emoji/081.png",
				"/:share": "//oss.ledu6.cn/emoji/082.png",
				"/:v": "//oss.ledu6.cn/emoji/083.png",
				"/:@)": "//oss.ledu6.cn/emoji/084.png",
				"/:jj": "//oss.ledu6.cn/emoji/085.png",
				"/:@@": "//oss.ledu6.cn/emoji/086.png",
				"[差劲]": "//oss.ledu6.cn/emoji/087.png",
				"[爱你]": "//oss.ledu6.cn/emoji/088.png",
				"[NO]": "//oss.ledu6.cn/emoji/089.png",
				"/:ok": "//oss.ledu6.cn/emoji/090.png",
				"[爱情]": "//oss.ledu6.cn/emoji/091.png",
				"[飞吻]": "//oss.ledu6.cn/emoji/092.png",
				"/:jump": "//oss.ledu6.cn/emoji/093.png",
				"/:shake": "//oss.ledu6.cn/emoji/094.png",
				"[怄火]": "//oss.ledu6.cn/emoji/095.png",
				"/:circle": "//oss.ledu6.cn/emoji/096.png",
				"[磕头]": "//oss.ledu6.cn/emoji/097.png",
				"[回头]": "//oss.ledu6.cn/emoji/098.png",
				"[跳绳]": "//oss.ledu6.cn/emoji/099.png",
				"[投降]": "//oss.ledu6.cn/emoji/100.png",
				"[激动]": "//oss.ledu6.cn/emoji/101.png",
				"[乱舞]": "//oss.ledu6.cn/emoji/102.png",
				"[献吻]": "//oss.ledu6.cn/emoji/103.png",
				"[左太极]": "//oss.ledu6.cn/emoji/104.png",
				"[右太极]": "//oss.ledu6.cn/emoji/105.png",
				"[Hey]": "//oss.ledu6.cn/emoji/106.png",
				"[Facepalm]": "//oss.ledu6.cn/emoji/107.png",
				"[Smirk]": "//oss.ledu6.cn/emoji/108.png",
				"[Smart]": "//oss.ledu6.cn/emoji/109.png",
				"[Concerned]": "//oss.ledu6.cn/emoji/110.png",
				"[Yeah!]": "//oss.ledu6.cn/emoji/111.png",
				"[Packet]": "//oss.ledu6.cn/emoji/112.png",
				"[蜡烛]": "//oss.ledu6.cn/emoji/113.png",
			},
			emojiArr: {
				"/::\\)": "//oss.ledu6.cn/emoji/001.png",
				"/::~": "//oss.ledu6.cn/emoji/002.png",
				"/::B": "//oss.ledu6.cn/emoji/003.png",
				"/::\\|": "//oss.ledu6.cn/emoji/004.png",
				"/:8-\\)": "//oss.ledu6.cn/emoji/005.png",
				"/::<": "//oss.ledu6.cn/emoji/006.png",
				"/::\\$": "//oss.ledu6.cn/emoji/007.png",
				"/::X": "//oss.ledu6.cn/emoji/008.png",
				"/::Z": "//oss.ledu6.cn/emoji/009.png",
				"/::'\\(": "//oss.ledu6.cn/emoji/010.png",
				"/::-\\|": "//oss.ledu6.cn/emoji/011.png",
				"/::@": "//oss.ledu6.cn/emoji/012.png",
				"/::P": "//oss.ledu6.cn/emoji/013.png",
				"/::D": "//oss.ledu6.cn/emoji/014.png",
				"/::O": "//oss.ledu6.cn/emoji/015.png",
				"/::\\(": "//oss.ledu6.cn/emoji/016.png",
				"\\[酷\\]": "//oss.ledu6.cn/emoji/017.png",
				"/:--b": "//oss.ledu6.cn/emoji/018.png",
				"/::Q": "//oss.ledu6.cn/emoji/019.png",
				"/::T": "//oss.ledu6.cn/emoji/020.png",
				"/:,@P": "//oss.ledu6.cn/emoji/021.png",
				"/:,@-D": "//oss.ledu6.cn/emoji/022.png",
				"/::d": "//oss.ledu6.cn/emoji/023.png",
				"/:,@o": "//oss.ledu6.cn/emoji/024.png",
				"\\[饥饿\\]": "//oss.ledu6.cn/emoji/025.png",
				"/:\\|-\\)": "//oss.ledu6.cn/emoji/026.png",
				"/::!": "//oss.ledu6.cn/emoji/027.png",
				"/::L": "//oss.ledu6.cn/emoji/028.png",
				"\\[憨笑\\]": "//oss.ledu6.cn/emoji/029.png",
				"/::,@": "//oss.ledu6.cn/emoji/030.png",
				"/:,@f": "//oss.ledu6.cn/emoji/031.png",
				"/::-S": "//oss.ledu6.cn/emoji/032.png",
				"/:\\?": "//oss.ledu6.cn/emoji/033.png",
				"/:,@x": "//oss.ledu6.cn/emoji/034.png",
				"/:,@@": "//oss.ledu6.cn/emoji/035.png",
				"\\[疯了\\]": "//oss.ledu6.cn/emoji/036.png",
				"/:,@!": "//oss.ledu6.cn/emoji/037.png",
				"/:!!!": "//oss.ledu6.cn/emoji/038.png",
				"/:xx": "//oss.ledu6.cn/emoji/039.png",
				"/:bye": "//oss.ledu6.cn/emoji/040.png",
				"/:wipe": "//oss.ledu6.cn/emoji/041.png",
				"/:dig": "//oss.ledu6.cn/emoji/042.png",
				"/:handclap": "//oss.ledu6.cn/emoji/043.png",
				"\\[糗大了\\]": "//oss.ledu6.cn/emoji/044.png",
				"/:B-\\)": "//oss.ledu6.cn/emoji/045.png",
				"/:<@": "//oss.ledu6.cn/emoji/046.png",
				"\\[右哼哼\\]": "//oss.ledu6.cn/emoji/047.png",
				"/::-O": "//oss.ledu6.cn/emoji/048.png",
				"\\[鄙视\\]": "//oss.ledu6.cn/emoji/049.png",
				"/:P-\\(": "//oss.ledu6.cn/emoji/050.png",
				"/::'\\|": "//oss.ledu6.cn/emoji/051.png",
				"/:X-\\)": "//oss.ledu6.cn/emoji/052.png",
				"/::\\*": "//oss.ledu6.cn/emoji/053.png",
				"\\[吓\\]": "//oss.ledu6.cn/emoji/054.png",
				"/:8\\*": "//oss.ledu6.cn/emoji/055.png",
				"/:pd": "//oss.ledu6.cn/emoji/056.png",
				"\\[西瓜\\]": "//oss.ledu6.cn/emoji/057.png",
				"/:beer": "//oss.ledu6.cn/emoji/058.png",
				"\\[篮球\\]": "//oss.ledu6.cn/emoji/059.png",
				"\\[乒乓\\]": "//oss.ledu6.cn/emoji/060.png",
				"/:coffee": "//oss.ledu6.cn/emoji/061.png",
				"\\[饭\\]": "//oss.ledu6.cn/emoji/062.png",
				"/:pig": "//oss.ledu6.cn/emoji/063.png",
				"/:rose": "//oss.ledu6.cn/emoji/064.png",
				"/:fade": "//oss.ledu6.cn/emoji/065.png",
				"/:showlove": "//oss.ledu6.cn/emoji/066.png",
				"/:heart": "//oss.ledu6.cn/emoji/067.png",
				"/:break": "//oss.ledu6.cn/emoji/068.png",
				"/:cake": "//oss.ledu6.cn/emoji/069.png",
				"\\[闪电\\]": "//oss.ledu6.cn/emoji/070.png",
				"/:bome": "//oss.ledu6.cn/emoji/071.png",
				"\\[刀\\]": "//oss.ledu6.cn/emoji/072.png",
				"\\[足球\\]": "//oss.ledu6.cn/emoji/073.png",
				"\\[瓢虫\\]": "//oss.ledu6.cn/emoji/074.png",
				"/:shit": "//oss.ledu6.cn/emoji/075.png",
				"/:moon": "//oss.ledu6.cn/emoji/076.png",
				"/:sun": "//oss.ledu6.cn/emoji/077.png",
				"\\[礼物\\]": "//oss.ledu6.cn/emoji/078.png",
				"/:hug": "//oss.ledu6.cn/emoji/079.png",
				"/:strong": "//oss.ledu6.cn/emoji/080.png",
				"/:weak": "//oss.ledu6.cn/emoji/081.png",
				"/:share": "//oss.ledu6.cn/emoji/082.png",
				"/:v": "//oss.ledu6.cn/emoji/083.png",
				"/:@\\)": "//oss.ledu6.cn/emoji/084.png",
				"/:jj": "//oss.ledu6.cn/emoji/085.png",
				"/:@@": "//oss.ledu6.cn/emoji/086.png",
				"\\[差劲\\]": "//oss.ledu6.cn/emoji/087.png",
				"\\[爱你\\]": "//oss.ledu6.cn/emoji/088.png",
				"\\[NO\\]": "//oss.ledu6.cn/emoji/089.png",
				"/:ok": "//oss.ledu6.cn/emoji/090.png",
				"\\[爱情\\]": "//oss.ledu6.cn/emoji/091.png",
				"\\[飞吻\\]": "//oss.ledu6.cn/emoji/092.png",
				"/:jump": "//oss.ledu6.cn/emoji/093.png",
				"/:shake": "//oss.ledu6.cn/emoji/094.png",
				"\\[怄火\\]": "//oss.ledu6.cn/emoji/095.png",
				"/:circle": "//oss.ledu6.cn/emoji/096.png",
				"\\[磕头\\]": "//oss.ledu6.cn/emoji/097.png",
				"\\[回头\\]": "//oss.ledu6.cn/emoji/098.png",
				"\\[跳绳\\]": "//oss.ledu6.cn/emoji/099.png",
				"\\[投降\\]": "//oss.ledu6.cn/emoji/100.png",
				"\\[激动\\]": "//oss.ledu6.cn/emoji/101.png",
				"\\[乱舞\\]": "//oss.ledu6.cn/emoji/102.png",
				"\\[献吻\\]": "//oss.ledu6.cn/emoji/103.png",
				"\\[左太极\\]": "//oss.ledu6.cn/emoji/104.png",
				"\\[右太极\\]": "//oss.ledu6.cn/emoji/105.png",
				"\\[Hey\\]": "//oss.ledu6.cn/emoji/106.png",
				"\\[Facepalm\\]": "//oss.ledu6.cn/emoji/107.png",
				"\\[Smirk\\]": "//oss.ledu6.cn/emoji/108.png",
				"\\[Smart\\]": "//oss.ledu6.cn/emoji/109.png",
				"\\[Concerned\\]": "//oss.ledu6.cn/emoji/110.png",
				"\\[Yeah!\\]": "//oss.ledu6.cn/emoji/111.png",
				"\\[Packet\\]": "//oss.ledu6.cn/emoji/112.png",
				"\\[蜡烛\\]": "//oss.ledu6.cn/emoji/113.png",
			},
			emoji_box_control: false,
		}
	},
	computed: {
		upload_gzh_id () {
			const gzhSelect = this.gzhSelect || []
			const item = gzhSelect.find(v => v.click_status) || {}
			return item.key
		},
	},
	mounted() {
		let that = this
		
		// opeGzhSelect().then(res=>{
		// 	// console.log("获取渠道、管理员选择",res);
		// 	that.searchSelect = res.data.data
		// })
		this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
		
		// 图片上传用的token
		this.headers_token = 'Bearer ' + localStorage.getItem("access_token")
		
		gzhFansChannelList().then(res=>{
			console.log("渠道",res);
			if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
				that.bookList = res.data.data.data
				that.handleChangeB(that.bookList[0].channel_id)
			}
			else {
				that.$message.error(`错误：${res.data.msg}`);
			}
		})
		
	},
	beforeDestroy() {
		// 清除计时器
		window.clearInterval(timer);
		timer = null;
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		onCreated(editor) {
		    this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
		},
		// 阻止默认的粘贴行为。保证样式也能复制过来
		customPaste(editor, event, callback) { // JS 语法
			console.log('editor', editor)
			console.log('event', event)
			console.log('callback', callback)
			// console.log();
		    // event 是 ClipboardEvent 类型，可以拿到粘贴的数据
		    // 可参考 https://developer.mozilla.org/zh-CN/docs/Web/API/ClipboardEvent
			
		    const html = event.clipboardData.getData('text/html') // 获取粘贴的 html
		    // const text = event.clipboardData.getData('text/plain') // 获取粘贴的纯文本
		    // const rtf = event.clipboardData.getData('text/rtf') // 获取 rtf 数据（如从 word wsp 复制粘贴）
			console.log("html",html);
			
		    // 同步
		    // editor.insertText(html)
			this.html_ = html
		    // 异步
		    // setTimeout(() => {
		    //     editor.insertText('yy')
		    // }, 1000)
		
		    // 阻止默认的粘贴行为
		    event.preventDefault()
				if (html) {
		    	callback(false) // 返回值（注意，vue 事件的返回值，不能用 return）
				} else {
		    	callback(true)
				}
		    
		    // 返回 true ，继续默认的粘贴行为
		    // callback(true)
		},
		
		// 书城
		handleChangeB(e){
			this.r_channel_id = e
			this.search_button_loading = true
			// 清除计时器
			window.clearInterval(timer);
			timer = null;
			// 重置状态
			this.select_fans_index = null
			
			this.getGzhSelect(e)
		},
		// 根据渠道获取公众号
		getGzhSelect(e){
			let that = this
			wxMaterialSelect({
				channel_id: e
			}).then(res=>{
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					// console.log("根据渠道获取公众号",res.data.data.list);
					let data = res.data.data.list
					let mData = []
					if(Object.keys(data).length > 0){
						for (let key in data) {
							let ooo = {}
							
							ooo.key = key
							ooo.click_status = false
							ooo.value = data[key]
							ooo.msg_prompt_read = 0
							
							mData.push(ooo)
						}
						mData[0].click_status = true
					
						// console.log("根据渠道获取公众号",res);
						console.log("mData",mData);
						that.gzhSelect = mData
						// if(mData.length > 0){
							that.r_gzh_id = mData[0].key
							
							that.getGzhFansMsg('click')
							// 获取红点
							that.getGzhRead()
							that.intervalHHH()
						// }
					}
					else {
						that.gzhSelect = mData
						that.fansMsgData = []
					}
				}
				else {
					that.$message.error(`错误：${res.data.msg}`);
				}
			})
		},
		intervalHHH(type){
			let that = this
			timer = window.setInterval(() => {
			    //需要定时执行的代码
			    that.getGzhRead()
			}, 5000);
		},
		getGzhRead(){
			let that = this
			gzhFansMsgRead({
				 channel_id: that.r_channel_id
			}).then(res=>{
				// console.log("计时器",res);
				let data = res.data.data
				let iii = 0
				// let gzh_key = null
				for (let key in data) {
					iii += data[key]
					that.gzhSelect.forEach(res=>{
						if(key == res.key){
							res.msg_prompt_read = data[key]
						}
						// 标明有新消息。获取当前选中的公众号的id
						// if(key == res.key && data[key] != 0 && res.click_status){ // 为选中状态
						// 	gzh_key = key
						// }
					})
				}
				// console.log("iii",iii);
				if(iii > that.chat_msg_num){ // 表示有新消息，然后就重新加载一遍粉丝消息列表
					// that.r_gzh_id = key
					that.getGzhFansMsg('click')
				}
				that.chat_msg_num = iii
				
			})    
		},
		// 切换公众号
		menuSecond(item,index){
			let that = this
			if(!item.click_status){
				// 重置状态
				this.select_fans_index = null
				
				this.gzhSelect.forEach(res=>{
					res.click_status = false
				})
				
				item.click_status = !item.click_status
				console.log("item",item);
				this.r_gzh_id = item.key
				// this.searchButton()
				this.search_button_loading = true
				
				
				this.getGzhFansMsg('click')
			}
		},
		// 获取公众号下的粉丝消息列表
		getGzhFansMsg(type){
			let that = this
			if(type == 'click'){
				that.fans_page = 1
			}
			gzhFansMsgList({
				page: that.fans_page,
				gzh_id: that.r_gzh_id,
			}).then(res=>{
				console.log("获取消息",res);
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					let f_data = res.data.data.data
					f_data.forEach(res=>{
						res.fans_select_status = false
					})
					
					if(type == 'scroll'){
						that.fansMsgData = that.fansMsgData.concat(res.data.data.data)
						setTimeout(()=>{
							that.fans_scroll_control = true
						},300)
					}
					else {
						that.fansMsgData = res.data.data.data
						if(that.select_fans_index != null){
							// console.log("-----------");
							that.fansMsgData[that.select_fans_index].fans_select_status = true
							that.clickFansMsg(that.fansMsgData[that.select_fans_index], that.select_fans_index, 'update')
						}
					}
				}
				else {
					that.$message.error(`错误：${res.data.msg}`);
				}
			})
		},
		
		// 粉丝消息列滚动
		fansMsgScroll(e){
			// console.log(e.srcElement.scrollTop + e.srcElement.clientHeight);
			// console.log(e.srcElement.scrollHeight);
			// 将要滑动到底部，开始进行加载
			if(e.srcElement.scrollHeight - (e.srcElement.scrollTop + e.srcElement.clientHeight) < 100){
				// console.log("将要滑动到底部，开始进行加载");
				if(this.fans_scroll_control){
					this.fans_scroll_control = false
					this.fans_page++
					this.getGzhFansMsg('scroll')
				}
			}
		},
		// 搜索消息
		onSearchChal(e){
			console.log("搜索消息",e);
			let that = this
			
		},
		// 点击粉丝消息
		clickFansMsg(item,index,type){
			let that = this
			console.log("item",item);
			
			that.chat_page = 1 // 聊天窗口的页数充值
			
			that.fansMsgData.forEach(res=>{
				res.fans_select_status = false
			})
			item.fans_select_status = !item.fans_select_status
			
			if(type != 'update'){ // 加这个过滤条件是为了避免，新消息进来时，重新复制数据然后页面会有空白一下然后有显示的闪一下效果
				that.chatData = []
			}
			
			item.new_messages_count = 0
			that.messages_name = item.nickname || `用户（ ${item.openid} ）`
			that.messages_img = item.headimgurl
			that.send_openid = item.openid
			that.select_fans_index = index
			that.chat_user_id = item.id
			
			gzhFansChat({
				page: that.chat_page,
				user_id: that.chat_user_id,
			}).then(res=>{
				console.log("获取聊天窗口信息",res.data.data);
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					
					if(res.data.data.data){
						let data = res.data.data.data.reverse()
						data.forEach(res=>{
						// 	console.log("msg_content",res.msg_content);
							for (let key in that.emojiArr) {
								let reg = new RegExp(key, "g")
								// console.log("search",res.msg_content.search(key));
								
								if(res.msg_content.search(key) > -1){
									res.msg_content = res.msg_content.replace(reg, `<img src="${that.emojiArr[key]}" style="width: 25px;"/>`)
								}
							}
						})
						that.chatData = data
					}
					
					// 控制滚动条滑动到底部
					this.$nextTick(() => {
						that.chat_scrollTop_control = true
						that.$refs.chatBox.scrollTop = that.$refs.chatBox.scrollHeight
						// 这里要额外再执行一次是因为，上面这一次执行后，滑动条并没有到最底部
						setTimeout((res)=>{
							that.$refs.chatBox.scrollTop = that.$refs.chatBox.scrollHeight
						},100)
					})
					// console.log(that.$refs.chatBox.scrollTop = that.$refs.chatBox.scrollHeight);
				}
				else {
					that.$message.error(`错误：${res.data.msg}`);
				}
				
			})
		},
		// 聊天窗口上滑
		fansChatScroll(e){
			// console.log("e---",e);
			// console.log("scrollBottom",e.srcElement.scrollTop);
			// console.log("clientHeight",e.srcElement.clientHeight);
			// console.log(e.srcElement.scrollHeight);
			if(e.srcElement.scrollTop < 200 && this.chat_scrollTop_control){ // 快要滑动到顶部的时候
				let that = this
				that.chat_scrollTop_control = false
				console.log("scrollBottom",e.srcElement.scrollTop);
				gzhFansChat({
					page: that.chat_page + 1,
					user_id: that.chat_user_id,
				}).then(res=>{
					console.log("获取聊天窗口信息",res.data.data);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.chat_scrollTop_control = true
						that.chat_page += 1
						that.chat_total = res.data.data.total
						
						if(res.data.data.data){
							let data = res.data.data.data.reverse()
							that.chatData = data.concat(that.chatData)
						}
						if(that.chatData.length >= that.chat_total){
							that.chat_scrollTop_control = false
						}
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
					
				})
			}
		},
		// 发送按钮
		sendButton(){
			let that = this
			
			// that.editor.insertText(`111`)
			// console.log(that.editor.getHtml());
			// that.editor.dangerouslyInsertHtml(`<h1>标题</h1><p>文本 <b>加粗</b></p>`)
			if(that.chat_window_type == 1){ // 文本
				// let ttt = that.editor.getText() // 获取纯文本
				if(that.html_ && that.html_ != "<p><br></p>"){
					// that.search_button_loading = true
					console.log("that.html_",that.html_);
					// console.log("that.editor.getText()",that.editor.getText());
					// let hhh = `<p><img src="//oss.ledu6.cn/emoji/113.png" alt="" data-href="" style="width: 25px;"/>撒旦</p>`
					let hhh = JSON.parse(JSON.stringify(that.html_))
					
					// 去掉<p>、</p>和&nbsp;
					let reg_b = new RegExp(`<p><br></p>`, 'g')
					hhh = hhh.replace(reg_b, '\n') // 这个要写在前面，不然这个<p>、</p>会被先替换掉
					let reg_h = new RegExp(`<p>`, 'g')
					hhh = hhh.replace(reg_h, '')
					let reg_p = new RegExp(`</p>`, 'g')
					hhh = hhh.replace(reg_p, '\n')
					let reg_s = new RegExp(`&nbsp;`, 'g')
					hhh = hhh.replace(reg_s, ' ')
					
					
					for (let key in that.emojiList) {
						let reg = new RegExp(`<img src="${that.emojiList[key]}" alt="" data-href="" style="width: 25px;"/>`, "g")
						hhh = hhh.replace(reg, key)
					// 	// console.log("key",key);
						// let ttt = /`<img src=\"\/\/oss.ledu6.cn\/emoji\/113.png\" alt=\"\" data-href=\"\" style=\"width: 25px;\"\/>`/g
					// 	// hhh.match(/img/g,"red")
					// 	hhh = hhh.replace(ttt,key)
					// 	console.log("replace",hhh.replace(ttt,key));
					}
					
					console.log("hhh",hhh);
					gzhFansSendMsg({
						openid: that.send_openid,
						type: 1, // 1是文本，2是图片，3是图文
						content: hhh,
						media_id: null, // 发图片
					}).then(res=>{
						console.log("聊天-发送信息",res);
						that.search_button_loading = false
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.editor.clear()
							let data = res.data.data
							let obj = {
								created_at: data.msg_create_time,
								msg_content: data.msg_content,
								msg_id: data.msg_id,
								msg_type: data.msg_type,
								sender: data.sender,
							}
							for (let key in that.emojiArr) {
								let reg = new RegExp(key, "g")
								// console.log("search",res.msg_content.search(key));
								
								if(obj.msg_content.search(key) > -1){
									obj.msg_content = obj.msg_content.replace(reg, `<img src="${that.emojiArr[key]}" style="width: 25px;"/>`)
								}
							}
							
							that.chatData.push(obj)
							// 控制滚动条滑动到底部
							that.$nextTick(() => {
								that.$refs.chatBox.scrollTop = that.$refs.chatBox.scrollHeight
							})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					})
				}
				else {
					that.$message.warning("内容不能为空")
				}
			}
			else { // 图片
				that.search_button_loading = true
				gzhFansSendMsg({
					openid: that.send_openid,
					type: 2, // 1是文本，2是图片，3是图文
					content: that.r_img_url,
					media_id: that.r_img_media_id, // 发图片
				}).then(res=>{
					console.log("聊天-发送信息",res);
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.r_img_url = null
						that.r_img_media_id = null
						that.chat_window_type = 1
						
						let data = res.data.data
						let obj = {
							created_at: data.msg_create_time,
							msg_content: data.msg_content,
							msg_id: data.msg_id,
							msg_type: data.msg_type,
							sender: data.sender,
						}
						that.chatData.push(obj)
						// 控制滚动条滑动到底部
						that.$nextTick(() => {
							that.$refs.chatBox.scrollTop = that.$refs.chatBox.scrollHeight
						})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				})
			}
			
		},
		// 显示表情包
		showEmoji(){
			if(this.select_fans_index != null){
				this.emoji_box_control = !this.emoji_box_control
			}
			else {
				this.$message.warning("请先选择粉丝")
			}
		},
		// 选择表情
		clickEmoji(value,key){
			console.log("value",value);
			console.log("key",key);
			this.html_ = this.html_ + `<img style="width:25px;" src="${value}">`
			this.emoji_box_control = false
		},
		// 选择图片弹窗显示
		showImgModal(type){
			let that = this
			if(that.select_fans_index != null){
				gzhFansGetImg({
					page: that.img_page,
					limit: that.img_limit,
				}, this.gzhSelect.find(v => v.click_status).key).then(res=>{
					console.log("获取图库",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						let data = res.data.data.data
						data.forEach(res=>{
							res.select_img = false
						})
						that.imgShowData = res.data.data.data
						that.img_total = res.data.data.total
						if(type != 'upload'){
							that.img_visible = true
						}
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				})
			}
			else {
				that.$message.warning("请先选择粉丝")
			}
			
		},
		imgHandleOk(){
			this.img_visible = false
		},
		imgHandleCancel(){
			this.img_visible = false
			this.img_confirmLoading = false
		},
		// 选择图片
		clickShowImg(index){
			let that = this
			that.imgShowData.forEach(res=>{
				res.select_img = false
			})
			that.imgShowData[index].select_img = true
			that.r_img_url = that.imgShowData[index].url // 图片链接
			that.r_img_media_id = that.imgShowData[index].media_id // 图片链接
			that.html_ = ''
			that.chat_window_type = 2
		},
		imgPagingChange(e){
			this.img_page = e
			this.showImgModal()
		},
		// 顶部图片上传 限制用户上传的图片格式和大小。
		beforeUpload(file){
			console.log("beforeUpload",file);
			this.img_search_loading = true
			this.upload_gzh_name = file.name
			const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/gif';
			if (!isJpgOrPng) {
				this.img_search_loading = false
				this.$message.error('图片格式只能为：PNG、JPEG、JPG/GIF');
			}
			const isLt2M = file.size / 1024 / 1024 < 10;
			if (!isLt2M) {
				this.img_search_loading = false
				this.$message.error('图片大小不能超过10MB!');
			}
			return isJpgOrPng && isLt2M;
			
		},
		uploadChange(info){
			console.log("图片请求",info);
			let that = this
			
			if (info.file.status === 'uploading') {
					this.img_search_loading = true
					return;
			}
			if (info.file.status === 'done') {
				console.log("图片请求done",info);
				if(info.file.response){ // 图片上传成功，有内容返回
					
					this.img_search_loading = false
					
					// that.loading = false
					
					// that.getImgRequest(that.img_type)
					if(info.file.response.code == 0){ // 上传成功
						// that.showImgModal('upload')
						that.img_visible = false
						that.r_img_media_id = info.file.response.data.data.media_id
						that.r_img_url = info.file.response.data.data.url
						that.html_ = ''
						that.chat_window_type = 2
						// that.html_ = `<img id="qwe" data-id class="abcd" style='max-width: 260px;max-height: 135px;' src='${info.file.response.data.data.url}'/>`
						// that.editor.blur()
					}
					else {
						this.$message.error(info.file.response.msg);
					}
				}
				else {
					
					this.img_search_loading = false
					this.$message.error(`错误：图片上传失败`);
				}
			}
			
			if (info.file.status === 'error') { // 上传失败
				
				this.loading = false;
				this.$message.error(`错误：图片上传失败`);
			
			}
		},
		// 同步素材
		syncImg(){
			let that = this
			this.img_sync_loading = true
			gzhFansSyncImg(
				this.gzhSelect.find(v => v.click_status).key
			).then(res=>{
				that.img_sync_loading = false
				that.$message.success(res.data.msg)
			})
		},
		// 删除聊天框里的图片
		delChatImg(){
			this.chat_window_type = 1 // 显示文本编辑器
		},
		
		// 隐藏聊天表情选择框
		hidenEmoji(){
			this.emoji_box_control = false
		}
	},
	filters: {
		dateFilters(value){
			let ttt = value
			// console.log(value);
			//时间戳转化成时间格式
			function timeFormat(value) {
			    //value是整数，否则要parseInt转换,不会出现少个0的情况
			    //如果value是10位数的需要 value* 1000
			    var time = new Date(value* 1000);
				// console.log('time',time);
			    var year = time.getFullYear();
				// console.log('time',time);
			    var month = time.getMonth() + 1;
			    var date = time.getDate();
			    var hours = time.getHours();
			    var minutes = time.getMinutes();
			    var seconds = time.getSeconds();
			    return year + '-' + add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
			}
			function add0(m) {
			    return m < 10 ? '0' + m : m
			}
			// console.log(timeFormat(value));
			return timeFormat(value)
		}
	}
}
</script>

<style scoped>
.fans-meesage-box {
	height: calc(100vh - 65px);
	margin: -20px -30px -30px;
	overflow: hidden;
	position: relative;
}
.content-father-box {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	padding: 35px 60px;
}
.content-big-box {
	display: flex;
	width: 100%;
	height: 100%;
	border-radius: 8px;
	overflow: hidden;
	max-width: 1700px;
	min-width: 1100px;
	margin: auto;
}

.big-left-box {
	width: 224px;
	padding: 10px 12px 12px;
	background: #e9e4e0;
	flex-shrink: 0;
}
.left-menu-box {
	height: 100%;
	overflow-y: overlay;
	margin-right: -12px;
	padding-right: 12px;
}
.left-label {
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	padding: 0 15px;
	margin-bottom: 3px;
}
.left-label:hover {
	/* color: #1d99ff; */
	background-color: #f2f3f5;
}
.left-children-cell {
	padding-left: 35px;
	height: 40px;
	line-height: 40px;
	cursor: pointer;
	margin-bottom: 3px;
	user-select: none;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.left-children-cell:hover {
	/* color: #1d99ff; */
	background-color: #f2f3f5;
}
.left-children-cell-true {
	/* color: #1d99ff; */
	background-color: #f2f3f5;
	/* color: #1d99ff; */
	font-weight: 600;
}


.big-center-box {
	width: 340px;
	/* background: #f3f3f3; */
	background: #f8f8f8;
	border-right: 1px solid #e5e5e5;
	height: 100%;
	flex-shrink: 0;
}
.center-all-cell {
	position: relative;
	overflow-y: overlay;
	height: calc(100% - 52px);
	/* height: 100%; */
}
.center-cell-box {
	display: flex;
	padding: 10px 12px;
	cursor: default;
	background: #f8f8f8;
	cursor: pointer;
}
.center-cell-box:hover {
	/* background-color: #e3e3e3; */
	background-color: #d6d6d6;
}
.center-cell-box-true {
	/* background-color: #e3e3e3; */
	background-color: #d6d6d6;
}
.center-header-img {
	width: 45px;
	height: 45px;
	flex-shrink: 0;
}
.center-text-box {
	width: calc(100% - 57px);
	margin-left: 12px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	
}
.center-text-msg {
	color: #b8b8b8;
	font-size: 12px;
	width: 100%;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
.center-header-name {
	font-size: 13px;
	margin-bottom: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.center-header-hint {
	font-size: 12px;
	padding: 0 5px;
	background-color: #f74545;
	color: #fff;
	border-radius: 10px;
	display: flex;
	align-items: center;
	max-width: 39px;
}


.big-right-box {
	background-color: #f3f3f3;
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.message-scrol-box {
	height: calc(100% - 52px - 245px);
}
.big-right-message {
	padding: 10px 20px 0;
	height: 100%;
	overflow-y: overlay;
	overflow-anchor: auto;
}


/* 设置滚动条开始 */
/* 滚动条整体 */
.left-menu-box::-webkit-scrollbar,
.center-all-cell::-webkit-scrollbar,
.big-right-message::-webkit-scrollbar
{
	/* height决定横向scrollbar的高度，width决定纵向滚动条的宽度 */
    /* height:30px; */
	width: 7px;
    /* 默认：滚动条透明底色 */
    background-color: transparent;
}
/* 滚动条滑块 */
.left-menu-box::-webkit-scrollbar-thumb,
.center-all-cell::-webkit-scrollbar-thumb,
.big-right-message::-webkit-scrollbar-thumb {
    /* 圆角 */
    border-radius: 10px;
    /* 滑块自身颜色 透明 */
    background-color: transparent;
}
/* 当鼠标hover时 */
.big-left-box:hover .left-menu-box::-webkit-scrollbar,
.big-center-box:hover .center-all-cell::-webkit-scrollbar,
.message-scrol-box:hover .big-right-message::-webkit-scrollbar {
	/* 底色 */
	/* background-color:#f3f3f3 !important; */
}
.big-left-box:hover .left-menu-box::-webkit-scrollbar-thumb,
.big-center-box:hover .center-all-cell::-webkit-scrollbar-thumb,
.message-scrol-box:hover .big-right-message::-webkit-scrollbar-thumb{
	/* 滑块颜色 */
	background-color: #999 !important;
}
.left-menu-box::-webkit-scrollbar,
.center-all-cell::-webkit-scrollbar,
.big-right-message::-webkit-scrollbar{
	/* display:none; */
	background-color: transparent;
}
/* 设置滚动条结束 */



/* 对话框 */
.text-message-container {
    margin: 0 10px;
    padding: 10px;
    background-color: white;
    position: relative;
    border-radius: 5px;
    display: flex;
    align-items: center;
	max-width: 70%;
}

.text-message-container p {
    user-select: text;
    white-space: pre-line;
}

.arrow-box-left {
	width: 0px;
	height: 0px;
	border-right: #fff 6px solid;
	border-top: transparent 5px solid;
	border-bottom: transparent 5px solid;
	position: absolute;
	left: -6px;
	top: 15px;
}
.arrow-box-right {
	width: 0px;
	height: 0px;
	border-left: #fff 6px solid;
	border-top: transparent 5px solid;
	border-bottom: transparent 5px solid;
	position: absolute;
	right: -6px;
	top: 15px;
}
.text-message-container p {
	margin: 0 !important;
}
.text p {
	margin-bottom: 0 !important;
}

.send-box {
	height: 45px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 20px;
}
.send-button {
	color: #0fb30f;
	background-color: #e5e5e5;
	width: 90px;
	text-align: center;
	height: 30px;
	line-height: 30px;
	cursor: pointer;
	margin-bottom: 0;
	font-size: 14px;
	/* border-radius: 3px; */
}
.send-button:hover {
	background-color: #ccc;
}

.select_img-border {
	/* border: 3px solid #409eff; */
	box-shadow: 0 0 8px 5px #82befd;
}
.img-content-null {
	text-align: center;
	text-align:center;
	padding: 50px 0 30px;
}
.img-content-null-text {
	color: #999;
	font-size: 16px;
	margin-top: 20px;
}

.msg-img-box {
	position: relative;
	height: 160px;
	display: inline-block;
}
.msg-img-del-icon {
	display: none;
	position: absolute;
	width: 30px;
	cursor: pointer;
}
.msg-img-box:hover .msg-img-del-icon{
	display: inline-block;
}

.img_loading {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(0,0,0,.3);
}

.emoji-img {
	width: 30px;
	margin-right: 5px;
	margin-bottom: 3px;
	cursor: pointer;
	user-select: none;
}
.emoji-img:hover {
	background-color: #ccc;
}
</style>